// start:ng42.barrel
export * from './sample.facade';
export * from './sample.model';
// end:ng42.barrel

